/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable one-var,one-var-declaration-per-line, global-require, no-sequences, no-unused-expressions, max-len */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Pagination } from 'react-bootstrap';
import { deleteFormAttr, updateFormAttr } from '../../../../../actions/postGeoData';
import fetch from '../../../../../core/fetch';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ManageData.scss';

const editedColumnsNumber = 4;
const totalColumnsNumber = 5;
const colWidth = 100 / totalColumnsNumber;
const stylDiv = {
  width: `${colWidth}%`,
  display: 'inline-block',
};
const notAllowedWords = ["id", "_idih", "geom", "geometry", "poly_geom","point_geom", "dlugosc_geogr", "szerokosc_geogr"]

class ManageData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editedFeatures: [],
      selectedLayer: null,
      perPage: 30,
      currentPage: 1,
      last_response: null,
      displayableColumnsNames: [],
      visibleColumnsNames: [],
    };
  }

  onLayerChange = (e) => this.setState({
    selectedLayer: e.target.value,
    editedFeatures: [],
    currentPage: 0,
  },
    () => this.fetchData());

  onChangePerPage = (e) => this.setState({ perPage: e.target.value });

  onEditFeature = (e, feature, property) => {
    feature[property] = e.target.value;
    let currentState = this.state.editedFeatures.slice();
    currentState.pop(_.find(currentState, (o) => o.id === feature.id));
    currentState.push(feature);
    this.setState({ editedFeatures: currentState });
  }

  editFeature = (feature) => {
    let mappedFeature = {};
    feature.map((v, i) => {
      mappedFeature[Object.keys(this.state.last_response.columns)[i]] = v;
    });
    let currentState = this.state.editedFeatures.slice();
    _.map(currentState, 'id').indexOf(mappedFeature.id) >= 0 ? currentState.pop(mappedFeature) : currentState.push(mappedFeature);
    this.setState({ editedFeatures: currentState });
  }

  saveFeatureEditFeature = (feature, selectedLayer) => {
    let rewritedFeatureKeys = {}
    for (const i in Object.keys(feature)) {
      const key = Object.keys(feature)[i];
      const val = feature[key];
      rewritedFeatureKeys[Object.keys(this.state.last_response.columns)[i]] = val;
    }
    this.props.updateFormAttr(this.props.district.prefix, selectedLayer, rewritedFeatureKeys)
      .then(resp => {
        let currentState = this.state.editedFeatures.slice();
        currentState.pop(feature);
        this.setState({ editedFeatures: currentState }, () => this.fetchData());
      });
  }

  deleteFeature = (id, selectedLayer) => {
    this.props.deleteFormAttr(this.props.district.prefix, selectedLayer, id)
      .then(resp => {
        this.setState(() => this.fetchData());
      });
  }

  fetchData = () => {
    // @api.route('/<string:prefix>/<string:table>/<int:per_page>/<int:page>', methods=['GET'])               -- geodatas.py:458
    const url = process.env.API_URL + '/' + this.props.district.prefix + '/' + this.state.selectedLayer + '/' + this.state.perPage + '/' + this.state.currentPage;
    fetch(url, { method: 'GET' })
      .then(resp => {
        if (resp.status === 200) {
          return resp.json();
        }
      })
      .then(response => {
        let r = response;
        let cols = response.columns;
        let newCols = {};
        for (const col of cols) {
          let isVisible = col !== response.not_nullable;
          if (notAllowedWords.indexOf(col) >= 0) isVisible = false; // If column name in this array than disable it automatically
          // if (isVisible) visibleColsCount += 1;
          newCols[col] = { isVisible };
        }
        r.columns = newCols;
        const displayableColumnsNames = Object.keys(newCols).filter(
          item => newCols[item].isVisible === true,
        );
        this.setState({
          last_response: r,
          displayableColumnsNames,
          visibleColumnsNames: displayableColumnsNames.slice(0, 4),
        });
      });
  }
  //  sets to state names of new displayed columns, fires when user clicks prev button
  handlePrevClick = () => {
    const lowestDisplayedIndex = this.state.displayableColumnsNames.reduce(
      (prev, curr, index) => {
        const result = curr === this.state.visibleColumnsNames[0] ? index : prev;
        return result;
      }, null,
    );
    const nextColumnsNames = this.state.displayableColumnsNames.filter(
      (item, index, array) => {
        if (array.length <= editedColumnsNumber) {
          return true;
        }
        if (lowestDisplayedIndex > editedColumnsNumber) {
          if (index < lowestDisplayedIndex && index >= lowestDisplayedIndex - editedColumnsNumber) {
            return true;
          }
        } else if (lowestDisplayedIndex <= editedColumnsNumber) {
          if (index < 4) {
            return true;
          }
        }
      },
    );
    this.setState({
      visibleColumnsNames: nextColumnsNames,
    });
  }
  //  sets to state names of new displayed columns, fires when user clicks next button
  handleNextClick = () => {
    const highestDisplayedIndex = this.state.displayableColumnsNames.reduce(
      (prev, curr, index) => {
        const result = curr === this.state.visibleColumnsNames[this.state.visibleColumnsNames.length - 1] ? index : prev;
        return result;
      }, null,
    );
    const nextColumnsNames = this.state.displayableColumnsNames.filter(
      (item, index, array) => {
        if (array.length <= editedColumnsNumber) {
          return true;
        }
        if (highestDisplayedIndex < array.length - editedColumnsNumber) {
          if (index > highestDisplayedIndex && index <= highestDisplayedIndex + 4) {
            return true;
          }
        } else if (index >= array.length - editedColumnsNumber) {
          return true;
        }
      },
    );
    this.setState({
      visibleColumnsNames: nextColumnsNames,
    });
  }

  renderDataRows = () => {
    return (
      <div>
        {this.state.last_response.data.map((v, i) => {
          const feature = _.find(this.state.editedFeatures, (o) => o.id === v[0]);
          return (
            <div key={i} className="row data-row text-row">
              {v.map((value, index) => {
                const key = Object.keys(this.state.last_response.columns)[index]; // data key
                const column = this.state.last_response.columns[key];
                return column.isVisible && key === this.state.visibleColumnsNames.find(item => item === key) ? (
                  <div key={index} style={stylDiv} className="cell-in-row">
                    {value}
                  </div>
                ) : null;
              })}
              {!feature ? (
                <div style={stylDiv}>
                  <button type="button" className="btn btn-danger" onClick={() => this.deleteFeature(v[0], this.state.selectedLayer)}>Usuń</button>
                  <button type="button" className="btn btn-warning" onClick={() => this.editFeature(v)}>Edytuj</button>
                  <hr className="style-two" />
                </div>)
                : <div className="col-sm-3" />
              }
              {v.map((propitem, j) => {
                return feature && !_.includes(notAllowedWords, Object.keys(this.state.last_response.columns)[j]) ? (
                  <div className="col-sm-12" key={j}>
                    <div className="form-group">
                      <label className="control-label col-xs-2 columns">
                        {String.prototype.normalizePropertiesNames(Object.keys(feature)[j])}
                      </label>
                      <div className="col-xs-6">
                        <input
                          className="form-control"
                          name={Object.keys(feature)[j]}
                          onChange={(e) => this.onEditFeature(e, feature, Object.keys(feature)[j])}
                          value={feature[Object.keys(feature)[j]] ? feature[Object.keys(feature)[j]] : ''}
                        />
                      </div>
                    </div>
                  </div>
                ) : null;
              })}
              {feature ?
              <div className="col-xs-4">
                <button type="button" className="btn btn-danger" onClick={() => this.editFeature(v)}>Anuluj</button>
                <button type="button" className="btn btn-primary" onClick={() => this.saveFeatureEditFeature(feature, this.state.selectedLayer)}>Zapisz zmiany</button>
              </div> : null
              }
            </div>
          );
        })}
      </div>
    );
  };

  renderColumnNames = () => {
    return (
      <div className="row">
        {this.state.visibleColumnsNames.map((v, i) => {
          return (
            <div key={i} style={stylDiv}>
              {String.prototype.normalizePropertiesNames(v)}
            </div>
          );
        })}
        <div style={stylDiv}>
          Akcje
        </div>
        <div className="col-sm-12" style={{ textAlign: 'center' }}>
          <hr className="style-one" />
          <button onClick={this.handlePrevClick}>Poprzedni</button>
          <button onClick={this.handleNextClick}>Następny</button>
        </div>
      </div>
    );
  }
  renderPagination = () => {
    const handleClick = page => {
      this.setState({ currentPage: page - 1 }, () => this.fetchData());
    };

    return (
      <div>
        <Pagination
          prev
          next
          first
          last
          bsSize="small"
          maxButtons={5}
          ellipsis
          items={this.state.last_response.pages}
          activePage={this.state.currentPage + 1}
          onSelect={handleClick}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="form-inline">
          <label>Na stronie</label>
          <input className="form-control" value={this.state.perPage} onChange={this.onChangePerPage} />
          <button type="button" className="btn btn-primary" onClick={() => this.fetchData()}>Odśwież</button>
          {this.props.isFetchingFormAttr === true ?
            <i className="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
            : null
          }
        </div>
        <div className="form-inline">
          <label htmlFor="selectLayer">Warstwa</label>
          <option value="" className="opt" />
          <select name="selectLayer" onChange={(e) => this.onLayerChange(e)} className="form-control" value={this.state.selectedLayer ? this.state.selectedLayer : ''}>
            {this.props.district.layers && this.props.district.layers.map((v, i) => {
              return <option key={i} value={v.name}>{String.prototype.normalizeLayersNames(v.name)}</option>;
            })}
          </select>
        </div>
        {this.state.last_response ? (
          this.state.last_response.data && this.state.last_response.data.length > 0 ? this.renderColumnNames() : null
        ) : null}
        {this.state.last_response ? (
          this.state.last_response.data && this.state.last_response.data.length > 0 ? this.renderDataRows() : <div>Brak danych dla warstwy</div>
        ) : null}
        {this.state.last_response ? (
          this.state.last_response.data && this.state.last_response.data.length > 0 ? this.renderPagination() : null
        ) : null}
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
  user: state.user.user,
  isFetchingFormAttr: state.postGeoData.isFetchingFormAttr,
});
const mapDispatch = {
  deleteFormAttr,
  updateFormAttr,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ManageData));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/ManageData/ManageData.js